export default "__VITE_ASSET__DZzjKJg9__"